// Header / mobile-menu navigation model for this vertical (homepage/user_experience.md #5).
// PrimaryNav.js + MobileNavMenu.js are identical across every vertical; this file is the one
// piece that differs. See car_rental/src/navConfig.js for the full contract.
import { JEWELLERY_CATEGORIES } from './components/JewellerySpecFields';

export default function buildNav({ isAuthenticated, has }) {
  const links = [];
  if (isAuthenticated && ['customer', 'owner', 'admin', 'delivery', 'cab_vendor', 'reservation_manager', 'corporate_admin', 'corporate_manager'].some(has)) links.push({ type: 'link', label: 'Tracking map', to: '/tracking' });

  if (has('customer')) links.push({ type: 'link', label: 'My Bookings', to: '/my-bookings' });
  if (has('owner')) links.push({ type: 'link', label: 'My Pieces', to: '/owner' });

  const ops = [];
  if (has('admin')) ops.push({ label: 'Admin', to: '/admin' });
  if (has('delivery') || has('admin')) ops.push({ label: 'Deliveries', to: '/delivery' });
  if (ops.length === 1) links.push({ type: 'link', ...ops[0] });
  else if (ops.length > 1) links.push({ type: 'group', label: 'Operations', items: ops });

  return {
    brand: '💎 Jewellery Rental',
    browseCategories: JEWELLERY_CATEGORIES.filter((c) => c !== 'Other').map((c) => ({ label: c, value: c })),
    links,
    loggedOutLinks: []
  };
}
